module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-ja-62a4b93a521922275fa265c13d52be01.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-ja.svg
// module id = rUTE
// module chunks = 24